<template>
    <div class="popup-wrap">
        <!-- 加入购物车弹框 -->
        <van-popup v-model="show" position="bottom" :overlay="true" :close-on-click-overlay="false">
            <div class="model-wrap">
                <div class="model-wrap-con">
                    <!-- 商品名，价格 -->
                    <div class="model-wrap-header">
                        <span class="left-photo dg-small-no-photo">
                            <img :src="imgPath" v-if="imgPath" />
                        </span>
                        <div class="right-text">
                            <p class="text-price">
                                <span class="fs32">JPY</span>
                                {{type === 'group' || type === 'join' ? data.groupBuy.groupBuyPrice : data.price | setNumber}}
                            </p>
                            <p class="text-name">{{data.comName || '未知'}}</p>
                        </div>
                        <!-- 关闭按钮 -->
                        <van-icon name="close" @click="closeModel" color="#999999" />
                    </div>
                    <!-- 商品类型 -->
                    <div class="model-wrap-section" v-for="(attr, index) in data.attribute" :key="index">
                        <!--分类名称-->
                        <p class="title-p">{{attr.name || '未知'}}</p>
                        <!--便利分类的值-->
                        <ul class="goods-types">
                            <li
                                v-for="(item, itemIndex) in attr.value"
                                :key="itemIndex"
                                class="goods-types-item"
                                :class="{on: item.checked}"
                                @click="selectType(item, itemIndex, index, attr.isImage)"
                            >{{item.itemName || '未知'}}</li>
                        </ul>
                    </div>
                    <!-- 购买数量 -->
                    <div class="model-wrap-num">
                        <p class="title-p">
                            购买数量
                            <span class="limiNum" v-if="type === 'group' || type === 'join'">每人限购 {{data.groupBuy.limitNum}} 件</span>
                            <span class="limiNum" v-else-if="limitedCount">每人限购 {{limitedCount}} 件</span>
                        </p>
                        <van-stepper v-if="limitedCount" v-model="params.count" :min="1" :max="limitedCount" />
                        <van-stepper v-else v-model="params.count" :min="1" :max="max" />
                    </div>
                </div>
                <!-- 底部确定按钮 -->
                <div class="model-wrap-footer">
                    <button class="define-btn" @click="defineAdd">确定</button>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import api from "@/server";
export default {
    props: ["detailList", "price", "type"],
    data() {
        return {
            // 加入购物车弹框显示与隐藏
            show: false,
            // 商品类型选中，默认选中第一个
            selectTypes: "",
            // 如果是参团或者是发起拼团，限制数量
            max: 999,
            limitedCount: 999,
            // 加购必传参数
            params: {
                attributeCar: [],
                userId: localStorage.getItem("userInfo")
                    ? JSON.parse(localStorage.getItem("userInfo"))._id
                    : "",
                count: 1,
                price: 0,
                comName: "",
                comImageCar: ""
            },
            // 生成订单参数
            orderParams: {
                cartList: [],
                userId: localStorage.getItem("userInfo")
                    ? JSON.parse(localStorage.getItem("userInfo"))._id
                    : "",
                payType: "1",
                remark: "",
                totalCost: "",
                tempOrderNumber: "",
                type: "TEMP",
                tempGroupOrderNumber: "", // 临时团单编号
                buyType: ""
            },
            // 切换图片途径
            imgPath: "",
            // 商品详细数据
            data: [],
            // 在本地数据的下标
            dataIndex: ""
        };
    },
    methods: {
        // 点击关闭按钮关闭弹框
        closeModel() {
            this.show = false;
            this.params.count = 1;
        },
        open() {
            this.show = true;
        },
        /*
          function 商品类型选择
          @item 获取当前商品属性值
          @index1 当前属性下标
          @index2 当前属性所属分类下标
        */
        selectType(item, index1, index2, flag) {
            // 判断如果又属性图片则保存属性图片，无属性图片保存商品首图
            if (flag) {
                this.imgPath = item.imgPath;
                this.params.comImageCar = item.imgPath;
            }
            // 控制那个分类的选中状态和数据选取
            let data = this.data.attribute[index2].value;
            this.params.attributeCar[index2].value = data[index1].itemName;
            for (let i = 0; i < data.length; i++) {
                if (i === index1) {
                    data[i].checked = true;
                } else {
                    data[i].checked = false;
                }
            }
            console.log(this.params.attributeCar);
        },
        // 确定按钮
        defineAdd() {
            this.params.comImageCar = this.imgPath;
            let flag = true;
            // 加入购物车验证
            this.params.attributeCar.forEach(item => {
                if (!item.value) {
                    this.$toast("请选择" + item.name);
                    flag = false;
                }
            });
            if (flag) {
                // 判断是编辑还是新增
                if (this.type === "add") {
                    this.addCar();
                } else if (
                    this.type === "buy" ||
                    this.type === "group" ||
                    this.type === "join"
                ) {
                    this.createOrder(this.type);
                } else {
                    this.editCars();
                }
            }
        },
        // 添加购物车
        addCar() {
            api
                .addCarList(this.params)
                .then(res => {
                    if (res.code === 200 && res.data) {
                        this.show = false;
                        this.$toast.success("成功加入");
                        this.$store.dispatch("setCarNumber", res.data.length);
                        this.$parent.$refs.footerCarNav.setCarAnimation();
                        localStorage.setItem("carList", JSON.stringify(res.data));
                    } else {
                        this.$toast.fail("加入失败");
                    }
                })
                .catch(() => { });
        },
        // 编辑购物车,成功之后保存到本地数据
        editCars() {
            let self = this;
            api
                .editCar(this.params)
                .then(res => {
                    if (res.code === 200) {
                        self.$toast.success("编辑成功");
                        self.show = false;
                        // 将编辑的商品根据id下标进行本地数据合并
                        let data = JSON.parse(localStorage.getItem("carList"));
                        let newData = Object.assign({}, data[self.dataIndex], self.params);
                        data[self.dataIndex] = newData;
                        data.forEach((item, i) => {
                            // 判断编辑过后的购物车如果和列表里面的购物车数据相同那么则让数量相加，删除一条相同数据
                            if (
                                i !== self.dataIndex &&
                                item.userId === newData.userId &&
                                item.userId === newData.userId &&
                                item.userId === newData.userId &&
                                item.commId === newData.commId &&
                                item.commId === newData.commId &&
                                item.commId === newData.commId &&
                                JSON.stringify(item.attributeCar) ===
                                JSON.stringify(newData.attributeCar)
                            ) {
                                item.count = item.count + newData.count;
                                data.splice(self.dataIndex, 1);
                            }
                        });
                        localStorage.setItem("carList", JSON.stringify(data));
                        // 更新本地数据
                        self.$emit("updateCarList");
                    } else {
                        this.$toast.fail("编辑失败");
                    }
                })
                .catch(() => { });
        },
        // 生成零时订单
        createOrder() {
            let production = {
                cartId: "",
                commId: this.params.commId,
                comName: this.params.comName,
                count: this.params.count,
                price: this.params.price,
                attribute: this.params.attributeCar,
                comImage: this.params.comImageCar
            };
            this.orderParams.cartList.push(production);
            // 区分团购和单独购买立即购买的价格
            this.orderParams.totalCost =
                this.type === "group" || this.type === "join"
                    ? this.data.groupBuy.groupBuyPrice * production.count
                    : production.price * production.count;
            // 区分是团购还是购买
            this.orderParams.buyType =
                this.type === "group" || this.type === "join" ? 2 : 1;
            // 区分参团、开团、购买
            switch (this.type) {
                case "group":
                    this.orderParams.join = 1;
                    break;
                case "join":
                    this.orderParams.join = 2;
                    break;
                default:
                    this.orderParams.join = 0;
                    break;
            }
            // 参团时传递团单参数给后台
            this.orderParams.tempGroupOrderNumber =
                this.orderParams.join === 2 ? this.$route.query.groupOrderNumber : "";
            api
                .createOrder(this.orderParams)
                .then(res => {
                    if (res.code === 200) {
                        this.$router.push({
                            name: "confirm-order",
                            query: {
                                id: res.data.orderNumber,
                                type: "product"
                            }
                        });
                    } else {
                        this.orderParams.cartList = [];
                        this.orderParams.totalCost = "";
                        this.$toast.fail(res.msg);
                    }
                })
                .catch(() => {
                    this.orderParams.cartList = [];
                    this.orderParams.totalCost = "";
                    this.$toast.fail("购买失败！");
                });
        }
    },
    watch: {
        detailList: {
            handler(val) {
                let self = this;
                console.log("=========", val)
                self.data = JSON.parse(JSON.stringify(val));
                self.imgPath = val.comImage[0].url;
                self.params.comName = self.data.comName;
                self.params.count = self.data.count;
                self.params.commId = self.data._id;
                self.limitedCount = val.limitedCount;
                // console.log(self.params)
                console.log("=========", self)
            },
            deep: true
        },
        type(type) {
            let self = this;
            self.params.price =
                self.type === "group" || self.type === "join"
                    ? self.data.groupBuy.groupBuyPrice
                    : self.data.price;
            // 编辑和加入购物车时控制不同的字段
            if (type === "edit") {
                self.params.id = self.data.carId;
                self.dataIndex = self.data.dataIndex;
            }
            self.params.attributeCar = [];
            if (self.data.attribute.length > 0) {
                self.data.attribute.map(item => {
                    if (type === "add") {
                        self.params.attributeCar.push({
                            name: item.name,
                            value: ""
                        });
                    } else {
                        let params = {
                            name: item.name,
                            value: ""
                        };
                        item.value.map(attr => {
                            if (attr.checked) {
                                params.value = attr.itemName;
                            }
                        });
                        self.params.attributeCar.push(params);
                    }
                });
            }

            // console.log(self.params)
            // 判断如果是参团或者发起拼团，购买数量有限制
            self.max =
                self.type === "group" || self.type === "join"
                    ? self.data.groupBuy.limitNum
                    : 999;
        }
    }
};
</script>
<style lang="scss" >
.popup-wrap {
    width: 100%;
    height: 100%;
    max-width: 750px;
    .van-popup {
        max-width: 750px;
    }
    // 加入购物车弹框
    .fs32 {
        font-size: 32px;
    }
    .van-popup {
        background: none;
        .model-wrap {
            color: $fc03;
            font-size: 28px;
            // 商品名，图片
            .model-wrap-con {
                max-height: 800px;
                overflow-y: auto;
                padding: 30px 30px 0 30px;
                background: $fc02;
                width: calc(100% - 60px);
                margin: 0 auto;
                border-radius: $br30 $br30 0 0;
                box-sizing: border-box;
                .title-p {
                    font-size: 28px;
                    color: $fc03;
                    margin-bottom: 30px;
                }
                // 商品图片，价格，商品名
                .model-wrap-header {
                    display: flex;
                    position: relative;
                    margin-bottom: 40px;
                    .left-photo {
                        width: 180px;
                        height: 180px;
                        display: inline-block;
                        // background: $bg06;
                        text-align: center;
                        margin-right: 24px;
                        > img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                    .right-text {
                        flex: 1;
                        overflow: hidden;
                        .text-price {
                            font-size: 42px;
                            color: $fc04;
                        }
                        .text-name {
                            font-size: 28px;
                            color: $fc03;
                            @include moreEllipsis(2);
                            margin-top: 10px;
                        }
                    }
                    .van-icon-close {
                        font-size: 42px;
                        color: $fc01;
                        font-weight: 600;
                        position: absolute;
                        right: 0;
                        top: -15px;
                    }
                }
                // 商品类型
                .model-wrap-section {
                    .goods-types {
                        overflow: hidden;
                    }
                    .goods-types-item {
                        width: auto;
                        border-radius: $br30;
                        background: $bg06;
                        height: 60px;
                        line-height: 60px;
                        padding: 0 40px;
                        box-sizing: border-box;
                        font-size: 24px;
                        color: $fc06;
                        margin-bottom: 24px;
                        display: inline-block;
                        margin-right: 20px;
                    }
                    .on {
                        background: $bg03;
                        color: $fc02;
                    }
                }
                // 购买数量
                .model-wrap-num {
                    display: flex;
                    align-items: center;
                    margin: 20px 0 30px 0;
                    .title-p {
                        flex: 1;
                        .limiNum {
                            font-size: 24px;
                            margin-left: 20px;
                            color: $fc04;
                        }
                    }
                    // 加减按钮
                    .van-stepper {
                        .van-stepper__plus--disabled {
                            background: url("../assets/images/disable-plus-icon.png")
                                no-repeat 0 0/100% !important;
                        }
                        .van-stepper__minus--disabled {
                            background: url("../assets/images/disable-reduce-icon.png")
                                no-repeat 0 0/100% !important;
                        }
                        > button {
                            width: 50px;
                            height: 50px;
                            border-radius: 50%;
                            overflow: hidden;
                            padding: 0;
                            &:first-child {
                                background: url("../assets/images/reduce-icon.png")
                                    no-repeat 0 0/100%;
                            }
                            &:last-child {
                                background: url("../assets/images/plus-icon.png")
                                    no-repeat 0 0/100%;
                            }
                        }
                        > input {
                            background: none;
                            margin: 0 10px;
                            font-size: 30px;
                            color: $fc06;
                        }
                        .van-stepper__minus::before,
                        .van-stepper__plus::before {
                            width: 0;
                            height: 0;
                        }
                        .van-stepper__minus::after,
                        .van-stepper__plus::after {
                            width: 0;
                            height: 0;
                        }
                    }
                }
            }
            // 底部按钮
            .model-wrap-footer {
                width: 100%;
                background: $bg02;
                padding: 15px 30px;
                box-sizing: border-box;
                border-top: 2px solid $bc04;
                .define-btn {
                    background: $btn02;
                    width: 100%;
                    height: 80px;
                    line-height: 80px;
                    @include resetButton();
                    border-radius: $br50;
                    color: $fc02;
                    font-size: 28px;
                    &:active {
                        background: $btnHover02;
                    }
                }
            }
        }
    }
}
</style>
